export default (type) =>
  !!type ? `For ${type.toLowerCase().split("_")[0]}` : "-";
